import { DataDisplayEvent, Textbox } from "@mcleod/components";
import { StringUtil } from "@mcleod/core";
import { AutogenLayoutQuoteCustomerQuickInfo } from "./autogen/AutogenLayoutQuoteCustomerQuickInfo";

export class QuoteCustomerQuickInfo extends AutogenLayoutQuoteCustomerQuickInfo {

    textboxIdOnDataDisplay(event: DataDisplayEvent) {
        if (event?.rowData?.getString("type_of", "C") === "P") {
            const textboxId = event.target as Textbox;
            textboxId.listLayout = "lme/crm/ProspectList";
        }
        this.textboxPartnerValue.visible = event?.rowData?.getBoolean("partner_value_visible", false);
    }

    textboxEdiCustomerScacDataDisplay(event: DataDisplayEvent) {
        this.textboxScac.visible = event?.rowData?.getBoolean("edi_customer_scac_visible", false);
    }

    textboxEdiCustomerCarrierOnDataDisplay(event: DataDisplayEvent) {
        this.textboxEdiCustomerCarrier.visible = event?.rowData?.getBoolean("edi_customer_carrier_visible", false);
    }

    textboxBridgeIdOnDataDisplay(event: DataDisplayEvent) {
        const bridgeId = event?.rowData?.getString("bridge_id", null);
        this.labelBridgeIdDescription.visible = !StringUtil.isEmptyString(bridgeId);
        this.textboxBridgeCustomer.visible = !StringUtil.isEmptyString(bridgeId);
    }
}
